'use strict';

/* global $ */

/* Класс для обработки галерей с блок управления в заголовке */
var Slider = function($dom, $parent, options){
    this.$dom = $dom;
    this.$parent = $parent || null;

    this.opt = $.extend(true, { slidesToShow: 1,
                                slidesToScroll: 1,
                                nextArrow: '<span class="slider-control slick-next" title="Еще">→</span>',
                                prevArrow: '<span class="slider-control slick-prev" title="Назад">←</span>',
                                infinite: false,
                                _appendArrows: false,
                                _appendDots: false }, options);

    this.$arrs = $();
    this.$dots = $();

    // this.init();
};

Slider.prototype = {
    init: function(){
        var self = this;
        if(self.$parent){
            if(self._appendArrows){
                self.$arrs = $(document.createElement('div'))
                                        .addClass('slider-controls')
                                        .appendTo(self.$parent);

                self.opt['appendArrows'] = self.$arrs;
            }
            if(self._appendDots){
                self.$dots = $(document.createElement('div'))
                                        .addClass('slider-dots')
                                        .appendTo(self.$parent);

                self.opt['appendDots'] = self.$dots;
            }
        }
        self.$dom.slick(self.opt);
    },
    deactivate: function(){
        var self = this;
        self.$dom.slick('unslick');
        self.$arrs.remove();
        self.$arrs = $();

        self.$dots.remove();
        self.$dots = $();
    }
};

export {
    Slider
};

